// Hook odpowiedzialny za pobranie pliku pdf reklamacji / zwrotu

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import { IRequest } from './useGetOrderExport';

// typ zwracanych danych
export interface IResponse {
  content: string;
  fileName: string;
}

const getReturnComplaintDownload = async (id: number): Promise<IResponse> => {
  const response = await axios.get<IResponse>(`/return-complain/${id}/protocol-pdf`);
  const data = (response as any).data ?? response;

  return {
    content: data.content,
    fileName: data.file_name
  };
};

export const useGetReturnComplaintDownload = (
  id: number,
  params?: IRequest,
  options?: UseQueryOptions<IResponse, IError>
) =>
  useQuery<IResponse, IError>(
    ['return-complaint-pdf', id, params],
    () => getReturnComplaintDownload(id),
    options
  );
